import React, {useCallback, useContext, useEffect} from "react";
import {
    TokenContext,
    RealmContext,
    ProfileContext,
    DialogContext,
} from "../../Store";

import { makeStyles } from "@mui/styles";

import ProfilesListView from "./ProfilesListView";

import BimProfileService from "../../../services/BimProfileService";

import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import UserService from "../../../services/UserService";
import {useNavigate} from "react-router-dom";


const useStyles = makeStyles({
    katalogView: {
        width: "100%",
        height: "100%",
        float: "left",
    },
    btListe: {
        width: "100%",
        maxHeight: "100vh",
        float: "left",
    },
});

function BimProfiles() {
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);
    const profileCtx = useContext(ProfileContext);
    const bimProf = profileCtx.profiles;
    const setBimProf = profileCtx.setProfiles;
    const dialogCtx = useContext(DialogContext);
    const setBIMDialogOpen = dialogCtx.setBimOpen;
    const bimProfileSelected = profileCtx.selected;
    const setBimProfileSelected = profileCtx.setSelected;
    const setBimProfileSelectedData = profileCtx.setSelectedData;

    const classes = useStyles();
    const navigate = useNavigate();

    useEffect(() => {
        if (!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, []);

    const GetProfilesData = useCallback(async () => {
        try {
            const res = await BimProfileService.getBimProfiles(token, realm);
            if (res.data?.result) {
                setBimProf(res.data.result);
            } else {
                setBimProf(res.data ?? []);
            }
            setBimProfileSelected('');
            setBimProfileSelectedData([]);
        } catch (e) {
            console.error("Fehler beim Laden der Profile:", e);
        }
    }, [setBimProf, setBimProfileSelected, setBimProfileSelectedData, realm, token]);

    useEffect(() => {
        if (!bimProf || bimProf.length === 0) {
            trackPromise(GetProfilesData());
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const addNew = () => {
        setBimProfileSelected("");
        setBimProfileSelectedData([]);
        setBIMDialogOpen(true);
    };

    const showBimetaProfiles = () => {
        navigate('/BimProfile/bimetaprofile');
    };

    return (
        <div>
            <LoadingIndicator />
            <div className={classes.katalogView}>
                <div className={classes.btListe}>
                    <ProfilesListView
                        profileList={bimProf}
                        GetProfilesData={GetProfilesData}
                        setBimProfileSelected={setBimProfileSelected}
                        bimProfileSelected={bimProfileSelected}
                        addNew={addNew}
                        showBimetaProfiles={showBimetaProfiles}
                    />
                </div>
            </div>
        </div>
    );
}

export default BimProfiles;